import React from 'react';
import { Modal, Form, Row, Col } from 'antd';
import { ButtonCommon, ViewField } from 'components/common';
import { ViewStaffModalProps } from 'types/common';
import { useGetAllRolesQuery } from 'services';

const ViewStaffModal: React.FC<ViewStaffModalProps> = ({ isOpen, onCancel, editMode = false, staffData = null }) => {
  const [form] = Form.useForm();
  const { data } = useGetAllRolesQuery({
    query: {
      size: 'unlimited',
    },
  });
  const getModalTitle = () => {
    return 'XEM CHI TIẾT NHÂN VIÊN';
  };

  const getModalDescription = () => {
    if (editMode) {
      return 'Vui lòng chỉnh sửa thông tin của nhân viên theo nhu cầu của bạn';
    }
    return 'Vui lòng điền đầy đủ thông tin của nhân viên mới';
  };

  return (
    <Modal
      title={
        <div className='flex flex-col bg-white py-[12px] px-[24px] rounded-lg gap-2'>
          <h2 className='text-[18px] font-bold leading-[24px]'>{getModalTitle()}</h2>
          <p className='text-[14px] leading-[20px] text-[var(--textBlack56)] font-normal'>{getModalDescription()}</p>
        </div>
      }
      open={isOpen}
      // onCancel={onCancel}
      footer={null}
      width={1255}
      centered
      className='staff-modal'
      destroyOnClose
      closeIcon={null}
      styles={{
        wrapper: {
          alignItems: 'center',
          paddingTop: '10vh',
        },
      }}
    >
      <div className='px-[24px] py-[12] mb-[12px]'>
        <Form
          form={form}
          requiredMark={false}
          layout='vertical'
          className='bg-white rounded-lg py-[24px] px-[48px] font-medium text-[14px] leading-[20px]'
        >
          <Row gutter={[24, 24]}>
            <Col span={8}>
              <ViewField label={'Họ và tên'} value={staffData?.baseUser?.name} />
            </Col>

            <Col span={8}>
              <ViewField label={'Mã nhân viên'} value={staffData?.baseUser?.code} />
            </Col>

            <Col span={8}>
              <ViewField label={'Số điện thoại'} value={staffData?.baseUser?.phoneNumber} />
            </Col>
            <Col span={8}>
              <ViewField label={'Gmail'} value={staffData?.baseUser?.email} />
            </Col>
            <Col span={8}>
              <ViewField label={'Vai trò'} value={data?.data.rows.find((r) => r.id === staffData?.roleId)?.name} />
            </Col>
            <Col span={8}>
              <ViewField label='Thông tin địa chỉ' value={staffData?.baseUser?.address} />
            </Col>

            <Col span={24}>
              <ViewField label='Mô tả' value={<p className='whitespace-pre-line'>{staffData?.note || '--'}</p>} />
            </Col>
          </Row>
        </Form>
      </div>
      <div className='flex justify-center gap-3 mt-6'>
        <ButtonCommon color='none' size='md' radius='rounded' onClick={onCancel}>
          Hủy
        </ButtonCommon>
      </div>
    </Modal>
  );
};

export default ViewStaffModal;
